import { useState, useEffect, useCallback } from "react";
import { truncateString } from "../../utils/util.js";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
  Input,
  TextField,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import {
  getInspStatusImage,
  updateReviewLabel,
} from "../../services/inspectService.js";
import noimg from "../../icons/noimg.png";
import { CloseIcon } from "../../icons/index.tsx";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ZoomController from "../train/ZoomController.js";
import ZoomBox from "../train/ZoomBox.js";

const InspStatusNGModal = ({
  open,
  onClose,
  ngReviews,
  setNgReviews,
  isMakeDataSetApply,
  setIsMakeDataSetApply,
  setFormData,
  isNGDataLoading,
  okRandomCount,
  setOkRandomCount,
  ngCondition,
  setNgCount,
  ngCount,
  isOkLableLoading,
  totalCount,
  setOpenModal,
}) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isClicked, setIsClicked] = useState(false);
  const [inputValue, setInputValue] = useState(okRandomCount);
  const [isApplyCondition, setIsApplyCondition] = useState(false);
  const [zoomMode, setZoomMode] = useState(false);
  const maxLength = 20;
  const navigate = useNavigate();
  useEffect(() => {
    if (!isNGDataLoading) return;
    setSelectedItem(ngReviews[0]);
  }, [isNGDataLoading]);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (inputValue > totalCount) {
        toast.error(
          `입력값이 총 데이터 수(${totalCount})를 초과할 수 없습니다.`
        );
        setInputValue(okRandomCount);
        return;
      }
      setOkRandomCount(inputValue);
    }, 500);

    return () => clearTimeout(handler);
  }, [inputValue]);

  useEffect(() => {
    if (!isNGDataLoading) return;
    if (ngCount < ngCondition || ngReviews.length < ngCondition) {
      toast.error(
        `NG 데이터가 ${ngCondition}개 이상이어야 데이터셋 생성이 가능합니다.`
      );
      setIsApplyCondition(false);
    } else {
      setIsApplyCondition(true);
    }
  }, [ngReviews, ngCondition, ngCount]);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === "ArrowUp") {
        setSelectedItem((prev) => {
          const currentIndex = ngReviews.findIndex(
            (item) => item.id === prev?.id
          );
          const newIndex =
            currentIndex > 0 ? currentIndex - 1 : ngReviews.length - 1;
          return ngReviews[newIndex];
        });
      }
      if (event.key === "ArrowDown") {
        setSelectedItem((prev) => {
          const currentIndex = ngReviews.findIndex(
            (item) => item.id === prev?.id
          );
          const newIndex =
            currentIndex < ngReviews.length - 1 ? currentIndex + 1 : 0;
          return ngReviews[newIndex];
        });
      }
    },
    [ngReviews]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  useEffect(() => {
    if (isClicked) return;
    const handler = setTimeout(async () => {
      if (selectedItem) {
        await getInspStatusImage(selectedItem.path).then((image) => {
          setImageSrc(image);
        });
      }
    }, 200);

    return () => {
      clearTimeout(handler);
    };
  }, [selectedItem]);

  const handleItemClick = async (item) => {
    setIsClicked(true);
    setSelectedItem(item);
    const image = await getInspStatusImage(item.path);
    setImageSrc(image);
    setIsClicked(false);
  };

  const handleRemove = () => {
    setNgReviews((prev) => prev.filter((item) => item.id !== selectedItem.id));
    const currentIndex = ngReviews.findIndex(
      (item) => item.id === selectedItem.id
    );
    if (currentIndex !== -1) {
      const nextItem = ngReviews[currentIndex + 1];
      if (nextItem) {
        setSelectedItem(nextItem);
      } else {
        // 마지막 아이템이면 이전 아이템으로 선택하거나 null로 처리
        const prevItem = ngReviews[currentIndex - 1];
        setSelectedItem(prevItem || null);
      }
    }
    // setSelectedItem((prev) => {
    //   const currentIndex = ngReviews.findIndex((item) => item.id === prev?.id);
    //   const newIndex =
    //     currentIndex < ngReviews.length - 1 ? currentIndex + 1 : 0;
    //   return ngReviews[newIndex];
    // });
  };

  const handleApply = () => {
    setIsMakeDataSetApply(true);
    toast.success(`데이터셋 자동 생성을 시작합니다.`);

    setTimeout(() => {
      setOpenModal(false);
      onClose();
    }, 100);
  };

  const handleOK = async () => {
    await updateReviewLabel(selectedItem.uuid, "OK");
    setFormData((prev) => ({
      ...prev,
      review: "OK",
    }));
    setSelectedItem((prev) => {
      const currentIndex = ngReviews.findIndex((item) => item.id === prev?.id);
      const newIndex =
        currentIndex < ngReviews.length - 1 ? currentIndex + 1 : 0;
      return ngReviews[newIndex];
    });
    setNgReviews((prev) => prev.filter((item) => item.id !== selectedItem.id));
    setNgCount((prev) => prev - 1);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableEnforceFocus
      disableAutoFocus
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "baseline" }}>
            <Typography sx={{ fontWeight: "bold", fontSize: "20px" }}>
              NG List
            </Typography>
            <Typography sx={{ fontSize: "14px", color: "gray", ml: 1 }}>
              {ngReviews.length} items
            </Typography>
          </Box>
          <CloseIcon
            onClick={onClose}
            style={{ cursor: "pointer", color: "gray" }}
          />
        </Box>
      </DialogTitle>
      <Box sx={{ display: "flex" }}>
        <Box
          // dividers
          sx={{
            height: "600px",
            maxWidth: "40%",
            width: "300px",
            px: 1,
          }}
        >
          <List
            sx={{
              borderTop: ngReviews.length > 0 ? "solid 1px lightgray" : "none",
              borderBottom:
                ngReviews.length > 0 ? "solid 1px lightgray" : "none",
              padding: 0,
              overflowY: "auto",
              height: "90%",
            }}
          >
            {!isNGDataLoading ? (
              <ListItem>
                <ListItemText primary="Loading..." />
              </ListItem>
            ) : ngReviews.length === 0 ? (
              <ListItem>
                <ListItemText primary="데이터가 없습니다." />
              </ListItem>
            ) : (
              ngReviews.map((item, index) => (
                <ListItem
                  key={item.id || index}
                  sx={{
                    borderLeft: "solid 1px lightgray",
                    borderRight: "solid 1px lightgray",
                    borderBottom: "solid 1px lightgray",
                    height: "30px",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor:
                        selectedItem && selectedItem.id === item.id
                          ? "#baf5fdff"
                          : "#f5f5f5",
                    },
                    backgroundColor:
                      selectedItem && selectedItem.id === item.id
                        ? "#e0f7fa"
                        : "transparent",
                  }}
                  onClick={() => handleItemClick(item)}
                >
                  <Tooltip
                    title={item.name.length > maxLength ? item.name : ""}
                    placement="top"
                  >
                    <ListItemText
                      primary={truncateString(item.name, maxLength)}
                      sx={{}}
                    />
                  </Tooltip>
                </ListItem>
              ))
            )}
          </List>

          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: "40px",
              // px: 1,
            }}
          >
            <Button variant="outlined" color="primary" onClick={handleRemove}>
              Remove
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleOK}
              sx={{ ml: 2 }}
            >
              OK로 변경
            </Button>
          </Box>
        </Box>
        <DialogContent
          dividers
          sx={{ maxHeight: "600px", border: "solid 1px lightgray" }}
        >
          {!selectedItem ? (
            <p>선택된 데이터가 없습니다.</p>
          ) : imageSrc ? (
            <ZoomBox
              src={imageSrc}
              zoom={2.5}
              lensSize={220}
              zoomMode={zoomMode}
            />
          ) : (
            <p>Loading...</p>
          )}
        </DialogContent>
      </Box>
      <DialogActions>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              ml: 2,
            }}
          >
            <TextField
              label="OK 이미지 수"
              variant="outlined"
              size="small"
              placeholder="숫자를 입력하세요"
              sx={{ width: "150px" }}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
            <Typography sx={{ ml: 1, color: "gray", fontSize: "13px" }}>
              {inputValue} / {totalCount}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {!isOkLableLoading && (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                <Typography sx={{ mr: 2, color: "gray" }}>
                  OK 데이터 수집중..
                </Typography>
              </Box>
            )}
            {imageSrc && (
              <ZoomController
                zoomOn={zoomMode}
                setZoomOn={setZoomMode}
                color={"rgb(25, 118, 210)"}
              />
            )}

            <Button
              variant="outlined"
              color="primary"
              onClick={handleApply}
              sx={{ mr: 2 }}
              disabled={
                !isApplyCondition || ngCount < ngCondition || !isOkLableLoading
              }
            >
              Apply
            </Button>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default InspStatusNGModal;
